import React, {useState, useEffect} from "react";
import {Link,useParams,useLocation} from 'react-router-dom';
import moment from 'moment';
import { getData } from '../../config/api-connect';
import {  
        Table, Select, DatePicker, Spin, Input
      } from 'antd';
import * as Styled from './style.js';
import Spinner from '../../components/spinner'

const { Option } = Select;

const Coaches = () => {
	const { venue_name } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  let venue_id = queryParams.get('venue_id');
  var local_month = JSON.parse(localStorage.getItem('month'));
  var local_year = JSON.parse(localStorage.getItem('year'));

  var local_city = JSON.parse(localStorage.getItem('cityId'))

  var local_selectedVenueId = JSON.parse(localStorage.getItem('selectedVenueId'))
  if(!local_selectedVenueId){
    local_selectedVenueId = 'All'
  }
  
  const [loading, setLoading] = useState(true)
  const [month, setMonth] = useState(local_month)
  const [year, setYear] = useState(local_year)
  const [venues, setVenues] = useState([])
  const [cities, setCities] = useState([])
  const [cityId, setCityId] = useState(local_city)
  const [venuelist, setVenuelist] = useState([])
  const [selectedVenueId, setSelectedVenueId] = useState(local_selectedVenueId)
  const [coachesData,setCoachesData] = useState([])

  useEffect(() => {
  	localStorage.setItem('month', JSON.stringify(month));
    localStorage.setItem('year', JSON.stringify(year));
    localStorage.setItem('selectedVenueId',JSON.stringify(selectedVenueId))
    localStorage.setItem('cityId',JSON.stringify(cityId))
    if(cityId !== ''){
      getCoaches()
    }
  }, [month,year,selectedVenueId,cityId]); 

  useEffect(() => {
     getVenues()
  }, []); 

  useEffect(() => {
    if(cities.length){
      getVenuesInCity()
    }
  }, [cities,cityId]);

  const handleCityChange = (value) => {
    if (value.length > 0) {
      const last_selected = value[value.length - 1]
      if(last_selected == 'All'){
        setCityId(['All']);
      }
      else{
        const filtered = value.filter(v => v !== 'All');
        setCityId(filtered)
      }
    }
    else {
      setCityId(['All']);
    }
  };

  const getVenuesInCity =() =>{
    if(cities[0] && !cityId){
      setCityId([cities[0].id])
    }

    let filteredVenues;

    if (cityId === 'All' || (Array.isArray(cityId) && cityId.includes('All')) ) {
      filteredVenues = venues;
    } else {
      filteredVenues = Array.isArray(cityId) ? venues.filter(item => cityId.includes(item.city)) : venues ;
    }

    setVenuelist(filteredVenues);
    const venueExists = filteredVenues.some(item => item.id === selectedVenueId);
    if (!venueExists) {
      setSelectedVenueId('All');
    }
  }

  const getVenues = async () => {
    await getData('/business/get_venues_for_buddies/')
    .then(response =>{
      setVenues(response.result)
      setCities(response.cities)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const onChangeYear = (date, dateString) => {
    setYear(dateString);
  };

  const getCoaches = () => {
  	setLoading(true)
    getData(`/business/get_monthly_coaches_allocation/?month=${month}&year=${year}&venue_id=${selectedVenueId}&city_id=${cityId}`)
    .then(response =>{
       setCoachesData(response.result || []);
    })
    .catch(error => {
      console.log(error.message);
    })
    .finally(()=>{
      setLoading(false)
    })
  }

  const formatIndianCurrency = (value) => {
    return Number(value).toLocaleString('en-IN')
  };

  const renderHeader = (title) => {
    return(
      <div style={{ textAlign: 'center', fontWeight: 'bold',textWrap: 'nowrap' }}>
      	{title}
      </div>
    )
  }  

  const sampleData = coachesData && coachesData.length > 0 ? coachesData[0] : {};

	const columns = [
    {
      title: renderHeader('Coach Name'),
      dataIndex: 'coach_name',
      align: 'center',
    },
	  {
	    title: renderHeader('Center Name'),
	    dataIndex: 'center_names',
	    align: 'center',
      width:400,
      render: (value) => (
        <>
          {value?.map((item, index) => (
            <div key={index}>{item}</div>
          ))}
        </>
      )
	  },
	  {
	    title: renderHeader('Total Hours'),
	    dataIndex: 'total_hours',
	    align: 'center',
	  },
    {
      title: renderHeader('Total Revenue'),
      dataIndex: 'revenue',
      align: 'center',
      render: text => formatIndianCurrency(text),
    },
	  {
	    title: renderHeader('Sports'),
	    dataIndex: 'sports',
	    align: 'center',
	  },
    {
      title: '',
      dataIndex: 'more',
    },
	];

	return(
		<Spin spinning={loading} indicator={<Spinner />}>
			<Styled.MainContainer>
				<Styled.TopDiv>
          
          <Styled.SelectorContainer>
            {cities.length > 1 &&        
              <Styled.Selector>
                <span className='indicatorText'>City</span>
                <Select
                  mode="multiple"
                  className = 'mainSelector'
                  style={{width: 150}}
                  showSearch = {true}
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.name.toLowerCase().includes(input.toLowerCase())}
                  onChange={handleCityChange}
                  value = {cityId}
                  bordered={false}
                >
                  <Option value="All" name="All"> All </Option>
                  {
                    cities.map(item=>(
                      <Option value={item.id} key={item.id} name = {item.name}> {item.name} </Option>    
                    ))
                  }
                </Select>
              </Styled.Selector>
            }

            {venuelist && venuelist.length > 0 &&
              <Styled.Selector>
                <span className='indicatorText'>Venue</span>
                <Select
                  className = 'mainSelector'
                  style={{width: 300}}
                  showSearch = {true}
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.name.toLowerCase().includes(input.toLowerCase())}
                  onChange={setSelectedVenueId}
                  value = {selectedVenueId}
                  bordered={false}
                >
                  <Option value="All" name="All"> All </Option>
                  {venuelist.map(item=>(
                    <Option value={item.id} key={item.id} name = {item.name}> {item.name} </Option>    
                    ))
                  }
                </Select>
              </Styled.Selector>
            }

          </Styled.SelectorContainer>

          <div style={{display: 'flex'}}>
            <Styled.Selector>
            <span className='indicatorText'>Month</span>
              <Select
                  className = 'mainSelector'
                  style={{width: 150}}
                  onChange={setMonth}
                  value = {month}
                  bordered={false}
                >
                  <Option value="12"> December </Option>
                  <Option value="11"> November </Option>
                  <Option value="10"> October </Option>
                  <Option value="09"> September </Option>
                  <Option value="08"> August </Option>
                  <Option value="07"> July </Option>
                  <Option value="06"> June </Option>
                  <Option value="05"> May </Option>
                  <Option value="04"> April </Option>
                  <Option value="03"> March </Option>
                  <Option value="02"> February </Option>
                  <Option value="01"> January </Option>
                </Select>
            </Styled.Selector>

            <Styled.Selector>
              <span className='indicatorText'>Year</span>
              <div className = 'mainSelector' style={{width: 100}}>
                <DatePicker defaultValue={moment(year, 'YYYY')}  onChange = {onChangeYear}  bordered={false}  picker="year" />
              </div>
            </Styled.Selector>
          </div>
        </Styled.TopDiv>

        <Styled.Header>   
          <span>Coaches</span>
        </Styled.Header>
        <div className="recordCount">{coachesData?.length || 0} records</div>
        <div>
        	<Table
            className="ant-table-thead table_container"
            rowKey={(record, index) => index}
            columns={columns}
            dataSource={coachesData}
            pagination={{pageSize: 50, showSizeChanger: false}}
            scroll={{ x: 'max-content' }}
          />
        </div>
			</Styled.MainContainer>
		</Spin>
	)
}

export default Coaches;	